export default {
  offline_handler (context) {
    context.$store.commit('toggle_alert', {color: 'fail', text: 'Por favor revisa tu conexión e intenta de nuevo más tarde.'})
  }
}